import { StreetViewComponent } from './../../street-view/street-view.component';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatDialogConfig } from '@angular/material';
import { DatePipe } from '@angular/common';
import { MapaService } from './../../../../services/mapa.service';
import { Component, OnInit, Inject } from '@angular/core';
import { TelefonoUltimaTransmision } from './../../../../../../_entities/telefonos/telefono';
import { HistoricoPosicionesTelefonoComponent } from '../historico-posiciones-telefono/historico-posiciones-telefono.component';

@Component({
	selector: 'kt-informacion-telefono',
	templateUrl: './informacion-telefono.component.html',
	styleUrls: ['./informacion-telefono.component.scss']
})
export class InformacionTelefonoComponent implements OnInit {
	public fechaHora: any;
	public telefono: TelefonoUltimaTransmision;
	public imagen: string;
	public direccion: string;
	public geocercaAsignada: string = '';

	constructor(private mapaService: MapaService,
		public datepipe: DatePipe, public dialog: MatDialog,
		public dialogRef: MatDialogRef<InformacionTelefonoComponent>,
		@Inject(MAT_DIALOG_DATA) public data: TelefonoUltimaTransmision) { }

	ngOnInit() {
		this.obtenerDatosTelefono(this.data);
	}

	obtenerDatosTelefono(telefono) {
		this.imagen = telefono.imagen;
		this.fechaHora = this.datepipe.transform(telefono.fechaHora, 'yyyy-MM-dd hh:mma');

		this.mapaService.getDireccion([telefono.lng, telefono.lat]).then(
			(data: any) => {
				this.direccion = data.display_name || "Dirección Desconocida";
			},
			() => {
				this.direccion = "Dirección Desconocida";
			});

		if (telefono.geocerca != null) {
			if (telefono.geocercas.length > 0) {
				telefono.geocercas.forEach(geocerca => {
					this.geocercaAsignada = this.geocercaAsignada + geocerca.nombre + ', ';
				});

				this.geocercaAsignada = this.geocercaAsignada.slice(0, -1);
				this.geocercaAsignada = this.geocercaAsignada.slice(0, -1);

			} else {
				this.geocercaAsignada = 'Sin asignación';
			}
		} else {
			this.geocercaAsignada = 'Sin asignación';
		}

		this.telefono = telefono;
	}

	obtenerDireccion() {

	}

	ubicarTelefono() {
		this.mapaService.verTelefono(this.telefono);
	}

	verStreet() {
		/*StreetView Popup*/
		const dialogConfig = new MatDialogConfig();
		dialogConfig.autoFocus = true;
		dialogConfig.disableClose = true;
		dialogConfig.panelClass = 'custom-modalbox';
		dialogConfig.width = "40%";
		dialogConfig.closeOnNavigation = true;
		dialogConfig.hasBackdrop = false;
		dialogConfig.data = this.data;
		this.dialog.open(StreetViewComponent, dialogConfig);
	}

	verHistorico() {
		const dialogConfig = new MatDialogConfig();
		dialogConfig.autoFocus = true;
		dialogConfig.disableClose = true;
		dialogConfig.width = "50%";
		dialogConfig.panelClass = 'custom-modalbox';
		dialogConfig.closeOnNavigation = true;
		dialogConfig.hasBackdrop = false;
		dialogConfig.data = this.data
		this.dialog.open(HistoricoPosicionesTelefonoComponent, dialogConfig);
		this.dialogRef.close()
	}


	public cerrarPopup() {
		this.dialogRef.close();
	}

	public minimizarPopup() {
		this.dialogRef.addPanelClass('displayNone');
	}

	public maximizarPopup() {
		this.dialogRef.removePanelClass('displayNone');
	}


}
